import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  savedCarts: [],
  isAuthenticated: false,
  user: null,
  pinCode: localStorage.getItem("userPinCode") || null,
  coordinates: localStorage.getItem("userCoordinates")
    ? JSON.parse(localStorage.getItem("userCoordinates"))
    : null,
};

export const userReducer = createReducer(initialState, (builder) => {
  builder
    // Save cart success
    .addCase('saveCartSuccess', (state, action) => {
      state.savedCarts = [...state.savedCarts, action.payload];  // Add the new cart to the existing list
    })
    .addCase('saveCartFailed', (state, action) => {
      state.error = action.payload;
    })
    
    // Delete cart success
    .addCase('deleteSavedCartSuccess', (state, action) => {
      state.savedCarts = state.savedCarts.filter(cart => cart._id !== action.payload);  // Remove the deleted cart
    })
    .addCase('deleteSavedCartFailed', (state, action) => {
      state.error = action.payload;
    })
    
    // Get saved carts success
    .addCase('getSavedCartsSuccess', (state, action) => {
      state.savedCarts = action.payload;  // Load all carts if needed
    })
    .addCase('getSavedCartsFailed', (state, action) => {
      state.error = action.payload;
    })
    .addCase('LoadUserRequest', (state) => {
      state.loading = true;
    })
    .addCase('LoadUserSuccess', (state, action) => {
      state.isAuthenticated = true;
      state.loading = false;
      state.user = action.payload;
    })
    .addCase('LoadUserFail', (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.isAuthenticated = false;
    })
    .addCase('updateUserInfoRequest', (state) => {
      state.loading = true;
    })
    .addCase('updateUserInfoSuccess', (state, action) => {
      state.loading = false;
      state.user = action.payload;
    })
    .addCase('updateUserInfoFailed', (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })
    .addCase('updateUserAddressRequest', (state) => {
      state.addressloading = true;
    })
    .addCase('updateUserAddressSuccess', (state, action) => {
      state.addressloading = false;
      state.successMessage = action.payload.successMessage;
      state.user = action.payload.user;
    })
    .addCase('updateUserAddressFailed', (state, action) => {
      state.addressloading = false;
      state.error = action.payload;
    })
    .addCase('deleteUserAddressRequest', (state) => {
      state.addressloading = true;
    })
    .addCase('deleteUserAddressSuccess', (state, action) => {
      state.addressloading = false;
      state.successMessage = action.payload.successMessage;
      state.user = action.payload.user;
    })
    .addCase('deleteUserAddressFailed', (state, action) => {
      state.addressloading = false;
      state.error = action.payload;
    })
    .addCase('getAllUsersRequest', (state) => {
      state.usersLoading = true;
    })
    .addCase('getAllUsersSuccess', (state, action) => {
      state.usersLoading = false;
      state.users = action.payload;
    })
    .addCase('getAllUsersFailed', (state, action) => {
      state.usersLoading = false;
      state.error = action.payload;
    })
    .addCase('clearErrors', (state) => {
      state.error = null;
    })
    .addCase('clearMessages', (state) => {
      state.successMessage = null;
    })
    .addCase('setUserPinCode', (state, action) => {
      state.pinCode = action.payload.pinCode;
      state.coordinates = action.payload.coordinates;
    })
    .addCase('clearUserPinCode', (state) => {
      state.pinCode = null;
      state.coordinates = null;
    });
   
});

